import { buildApiUrl, fetchJSON } from './crmApi';

export interface Organization {
  id: string;
  name: string;
  owner_user_id: string;
  created_at: string;
  updated_at: string;
}

const organizationsService = {
  async list(search?: string): Promise<{ data: Organization[] }>{
    const url = buildApiUrl('/api/crm/organizations', { search });
    return fetchJSON(url);
  },
  async get(id: string): Promise<{ data: Organization | null }>{
    const url = buildApiUrl(`/api/crm/organizations/${encodeURIComponent(id)}`);
    return fetchJSON(url);
  },
  async create(name: string): Promise<{ data: Organization }>{
    const url = buildApiUrl('/api/crm/organizations');
    return fetchJSON(url, { method: 'POST', body: JSON.stringify({ name }) });
  },
  async update(id: string, name: string): Promise<{ data: Organization }>{
    const url = buildApiUrl(`/api/crm/organizations/${encodeURIComponent(id)}`);
    return fetchJSON(url, { method: 'PUT', body: JSON.stringify({ id, name }) });
  },
  async remove(id: string): Promise<{ success: boolean }>{
    const url = buildApiUrl(`/api/crm/organizations/${encodeURIComponent(id)}`);
    return fetchJSON(url, { method: 'DELETE' });
  }
};

export default organizationsService;
